import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/VARS00000"
  },
  {
    path: "/VARS00000",
    name: "VARS00000",
    meta: {
      navType: `03`,
      mclass: "p-msg2",
      fshow: true,
      fclass: "m-b-10"
    }, //인트로
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00000.vue")
  },
  {
    path: "/VARS00100",
    name: "VARS00100",
    meta: {
      navType: `03`,
      fshow: true,
      fType: "01"
    }, //시작하기
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00100.vue")
  },
  {
    path: "/VARS00101",
    name: "VARS00101",
    meta: {
      navType: `02`,
      mclass: "p-main",
      hnotice: true,
      fshow: true,
      fType: "02"
    }, //메인화면
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00101.vue")
  },
  {
    path: "/VARS00200",
    name: "VARS00200",
    meta: {
      fshow: true,
      fType: "03",
      fMsg: false
    }, //본인확인
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00200.vue")
  },
  {
    path: "/VARS00300",
    name: "VARS00300",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, //이용종료 안내
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00300.vue")
  },
  {
    path: "/VARS00400",
    name: "VARS00400",
    meta: {
      hconbtn: false,
      fshow: true,
      fType: "03",
      fMsg: false
    }, //확인
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00400.vue")
  },
  {
    path: "/VARS00500",
    name: "VARS00500",
    meta: {
      hconbtn: false
    }, //확인
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00500.vue")
  },
  {
    path: "/VARS00600",
    name: "VARS00600",
    meta: {
      hconbtn: false,
      fshow: true,
      fType: "03",
      fMsg: false
    }, //확인
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS00600.vue")
  },
  {
    path: "/VARS01000",
    name: "VARS01000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01000.vue")
  },
  {
    path: "/VARS01100",
    name: "VARS01100",
    meta: {
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "신청 매뉴얼 보기"
    }, //통합신청 ▶ 신청방법 안내
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01100.vue")
  },
  {
    path: "/VARS01200",
    name: "VARS01200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01200.vue")
  },
  {
    path: "/VARS01201",
    name: "VARS01201",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01201.vue")
  },
  {
    path: "/VARS01300",
    name: "VARS01300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01300.vue")
  },
  {
    path: "/VARS01301",
    name: "VARS01301",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01301.vue")
  },
  {
    path: "/VARS01400",
    name: "VARS01400",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01400.vue")
  },
  {
    path: "/VARS01401",
    name: "VARS01401",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01401.vue")
  },
  {
    path: "/VARS01500",
    name: "VARS01500",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01500.vue")
  },
  {
    path: "/VARS01501",
    name: "VARS01501",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01501.vue")
  },
  {
    path: "/VARS02000",
    name: "VARS02000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS02000.vue")
  },
  {
    path: "/VARS02100",
    name: "VARS02100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS02100.vue")
  },
  {
    path: "/VARS02200",
    name: "VARS02200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS02200.vue")
  },
  {
    path: "/VARS02300",
    name: "VARS02300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS02300.vue")
  },
  {
    path: "/VARS02400",
    name: "VARS02400",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS02400.vue")
  },
  {
    path: "/VARS03000",
    name: "VARS03000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03000.vue")
  },
  {
    path: "/VARS03100",
    name: "VARS03100",
    meta: {
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "신청 매뉴얼 보기"
    }, //국가장학금 ▶ 신청방법 안내
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS01100.vue")
  },
  {
    path: "/VARS03200",
    name: "VARS03200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03200.vue")
  },
  {
    path: "/VARS03300",
    name: "VARS03300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03300.vue")
  },
  {
    path: "/VARS03301",
    name: "VARS03301",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03301.vue")
  },
  {
    path: "/VARS03302",
    name: "VARS03302",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03302.vue")
  },
  {
    path: "/VARS03303",
    name: "VARS03303",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS03303.vue")
  },
  {
    path: "/VARS04000",
    name: "VARS04000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS04000.vue")
  },
  {
    path: "/VARS04100",
    name: "VARS04100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS04100.vue")
  },
  {
    path: "/VARS04200",
    name: "VARS04200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS04200.vue")
  },
  {
    path: "/VARS04201",
    name: "VARS04201",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS04201.vue")
  },
  {
    path: "/VARS05000",
    name: "VARS05000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS05000.vue")
  },
  {
    path: "/VARS05100",
    name: "VARS05100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS05100.vue")
  },
  {
    path: "/VARS05200",
    name: "VARS05200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS05200.vue")
  },
  {
    path: "/VARS05300",
    name: "VARS05300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS05300.vue")
  },
  {
    path: "/VARS06000",
    name: "VARS06000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS06000.vue")
  },
  {
    path: "/VARS06100",
    name: "VARS06100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS06100.vue")
  },
  {
    path: "/VARS06200",
    name: "VARS06200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS06200.vue")
  },
  {
    path: "/VARS06300",
    name: "VARS06300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS06300.vue")
  },
  {
    path: "/VARS07000",
    name: "VARS07000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS07000.vue")
  },
  {
    path: "/VARS07100",
    name: "VARS07100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS07100.vue")
  },
  {
    path: "/VARS07200",
    name: "VARS07200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS07200.vue")
  },
  {
    path: "/VARS07300",
    name: "VARS07300",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS07300.vue")
  },
  {
    path: "/VARS08000",
    name: "VARS08000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08000.vue")
  },
  {
    path: "/VARS08100",
    name: "VARS08100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08100.vue")
  },
  {
    path: "/VARS08200",
    name: "VARS08200",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08200.vue")
  },
  {
    path: "/VARS08201",
    name: "VARS08201",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08201.vue")
  },
  {
    path: "/VARS08202",
    name: "VARS08202",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08202.vue")
  },
  {
    path: "/VARS08203",
    name: "VARS08203",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08203.vue")
  },
  {
    path: "/VARS08204",
    name: "VARS08204",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08204.vue")
  },
  {
    path: "/VARS08205",
    name: "VARS08205",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08205.vue")
  },
  {
    path: "/VARS08206",
    name: "VARS08206",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08206.vue")
  },
  {
    path: "/VARS08207",
    name: "VARS08207",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08207.vue")
  },
  {
    path: "/VARS08208",
    name: "VARS08208",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS08208.vue")
  },
  {
    path: "/VARS09000",
    name: "VARS09000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS09000.vue")
  },
  {
    path: "/VARS10000",
    name: "VARS10000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS10000.vue")
  },
  {
    path: "/VARS10100",
    name: "VARS10100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS10100.vue")
  },
  {
    path: "/VARS10101",
    name: "VARS10101",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS10101.vue")
  },
  {
    path: "/VARS11000",
    name: "VARS11000",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS11000.vue") /*교육급여 학습특별지원금*/
  },
  {
    path: "/VARS11100",
    name: "VARS11100",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS11100.vue") /*교육급여 학습특별지원금 > 자주하는 질문 > 지원금 기준 및 신청*/
  },
  {
    path: "/VARS11101",
    name: "VARS11101",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS11101.vue") /*교육급여 학습특별지원금 > 자주하는 질문 > 지원금 지급*/
  },
  {
    path: "/VARS11102",
    name: "VARS11102",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS11102.vue") /*교육급여 학습특별지원금 > 자주하는 질문 > 사용방법*/
  },
  {
    path: "/VARS99100",
    name: "VARS99100",
    meta: {
      navType: `03`,
      mclass: "p-survey",
      hsurvey: true,
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "참여 완료"
    }, //시작하기, //고객만족도 조사
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS99100.vue")
  },
  {
    path: "/VARS99200",
    name: "VARS99200",
    meta: {
      navType: `03`,
      mclass: "p-survey",
      hsurvey: true,
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "참여 완료"
    }, //시작하기, //고객만족도 조사
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS99200.vue")
  },
  {
    path: "/VARS99101",
    name: "VARS99101",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, //고객만족도 조사 결과
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS99101.vue")
  },
  {
    path: "/VARS99999",
    name: "VARS99999",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, //공통오류페이지
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS99999.vue")
  },
  {
    path: "*",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, //이용종료 안내
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/VARS99999.vue")
  },
  {
    path: "/VARS20001",
    name: "VARS20001",
    meta: {
      navType: `03`,
      mclass: "p-fileupload",
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "다음"
    }, //서류제출 본인확인 화면
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/VARS20001.vue")
  },
  {
    path: "/VARS20002",
    name: "VARS20002",
    meta: {
      navType: `03`,
      mclass: "p-fileupload",
      fshow: true,
      fType: "03",
      fMsg: false,
      fBtnName: "제출하기"
    }, // 서류제출 화면
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/VARS20002.vue")
  },
  {
    path: "/VARS20003",
    name: "VARS20003",
    meta: {
      navType: `03`,
      mclass: "p-fileupload",
      fshow: true,
      fMsg: false,
    }, // 서류제출 완료 화면
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/VARS20003.vue")
  },
  {
    path: "/VARS20011",
    name: "VARS20011",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, // 서류제출 이용종료 안내
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/VARS20011.vue")
  },
  {
    path: "/VARS20012",
    name: "VARS20012",
    meta: {
      navType: `03`,
      mclass: "p-msg",
      hlogo: false
    }, // 서류제출 이용종료 안내
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/VARS20012.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

/* 이동에 대한 동적 처리 하는 부분 */
router.beforeEach((to, from, next) => {
  // console.log(from);
  // console.log(to);
  const pgmList = store.getters["system/getPgmData"];
  const isInit = store.getters["system/getInitialized"];
  const connKey = store.getters["customer/getConnKey"];

  if (pgmList) {
    if (
      !connKey != undefined &&
      connKey != null &&
      to.name != "VARS00300" &&
      to.name != "VARS99999"
    ) {
      const toPgm = pgmList.get(to.name);

      if (toPgm) {
        const isAuthzYn = store.getters["customer/isAuthorize"];
        if (toPgm.cert_cnfm_yn == "Y" && !isAuthzYn) {
          //console.log("인증이 필요하고 인증여부가 false이다.");
          //this.$go("VARS00200");
          // next({ name: 'VARS00200', params: to }).catch(err=> {
          //   console.log(err);
          // }); //인증화면으로 이동
          router.push({ name: "VARS00200", params: to }).catch(err => {
            console.log(err);
          });
        } else {
          next();
        }
      } else {
        if (from.name !== "VARS99999") {
          router.push({ name: "VARS99999" }).catch(err => {
            console.log(err);
          }); //인증화면으로 이동
        } else {
          return false;
        }
      }
    } else {
      //서비스 종료 페이지로 이동
      if (!isInit || to.name == "VARS00300" || to.name == "VARS99999") {
        next();
      } else {
        if (from.name !== "VARS99999") {
          router.replace({ name: "VARS99999" }).catch(err => {
            console.log(err);
          }); //인증화면으로 이동
        } else {
          return false;
        }
      }
    }
  } else {
    //서비스 초기화 이전 요청시 -프로그램 목록을 받아오기 전처리사항
   // 2023-04 VARS20002,03,11,12 별도 서비스 화면(서류제출)이라 제외
   if (!isInit || to.name == "VARS00300" || to.name == "VARS99999" ||
   to.name == "VARS20002" || to.name == "VARS20003" || to.name == "VARS20011" || to.name == "VARS20012") {
      next();
    } else {
      router.replace({ name: "VARS99999" }).catch(err => {
        console.log(err);
      }); //인증화면으로 이동
    }
  }
});

//완료후 처리
router.afterEach(to => {
  const pgmList = store.getters["system/getPgmData"];
  if (pgmList) {
    const toPgm = pgmList.get(to.name);
    if (toPgm) {
      const isAuthzYn = store.getters["customer/isAuthorize"];
      if (toPgm.cert_cnfm_yn == "Y" && !isAuthzYn) {
        router.replace({ name: "VARS00200", params: to }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  //화면이동시 공지사항이 있으면 제거
  const notice = store.getters["system/getNotice"];
  if (notice != undefined && notice != null) {
    store.commit("system/setNotice", null);
  }
});

export default router;
